import Switch from './Switch';

export default Switch;
export { Switch };
export type { SwitchProps } from './interface';
